import React, { useEffect, useState } from 'react';
import { isLikelyEEA, openConsentPreferences } from '../lib/consent';

// Footer button(s) that let visitors re-open the consent banner after they've
// already made a choice. For non-EEA visitors, also renders the CCPA-specific
// "Do Not Sell or Share My Personal Information" link — California AG guidance
// (and Disney's $2.75M FTC settlement in Feb 2026) make clear that a generic
// "Cookie Preferences" label is not specific enough notice for the opt-out.
export default function CookiePreferencesLink({ className = '' }) {
  const [isEEA, setIsEEA] = useState(null);
  useEffect(() => { setIsEEA(isLikelyEEA()); }, []);

  const base =
    className ||
    'text-[#5b4d4f] hover:text-[#ba1609] text-[11px] tracking-[0.15em] uppercase font-sans transition-colors';

  return (
    <>
      <button type="button" onClick={openConsentPreferences} className={base}>
        Cookie Preferences
      </button>
      {isEEA === false && (
        <button type="button" onClick={openConsentPreferences} className={base}>
          Do Not Sell or Share My Personal Information
        </button>
      )}
    </>
  );
}
